import { Rpc } from '../rpc';
import { RpcOutbound } from '../rpc-outbound';
import { RpcOutboundClient } from '../rpc-outbound-client';
import { RpcAzureOperationResult, RpcAzureResponseKey } from './rpc-azure-model';

export class RpcAzureResponseClient {
    /**
     * The Rpc Azure response command.
     *
     * @param rpc the rpc service.
     * @param data the azure operation result object.
     * @param outbound the outbound channel to call. @optional
     * @return Promise<void> the promise object.
     */
    public static azureResponse(rpc: Rpc, data: RpcAzureOperationResult): Promise<void>;
    public static azureResponse(rpc: Rpc, data: RpcAzureOperationResult, outbound?: RpcOutbound): Promise<void>;
    public static azureResponse(rpc: Rpc, data: RpcAzureOperationResult, outbound?: RpcOutbound): Promise<void> {
        if (outbound) {
            return RpcOutboundClient.callOutbound(
                rpc.rpcManager.rpcChannel,
                outbound,
                RpcAzureResponseKey.command,
                RpcAzureResponseKey.version,
                data
            );
        } else {
            return RpcOutboundClient.call(rpc, RpcAzureResponseKey.command, RpcAzureResponseKey.version, data);
        }
    }
}
